<template>
  <div class="flex items-center">
    <button class="bg-green-500 hover:bg-green-600 px-4 py-2 text-white text-xs uppercase font-semibold rounded"
      v-on:click="showAddAssetModal">+ add Asset</button>

    <div class="ml-12 flex items-center font-semibold text-base">
      Total Asset Value 

      <div class="ml-4 p-2 bg-gray-300 rounded">
        {{ getTotalAssetValue() }}
      </div>
    </div>
  </div>
</template>

<script>

	import commaNumber from 'comma-number'

	export default {
		props : {
			assets : {
				type : Array,
				required : false
			},

      showAddAssetModal : {
        type    : Function,
        required: true
      }
		},

		methods : {
      getTotalAssetValue() {
        let total = 0
        for(let i=0; i < this.assets.length; i++) {
          if(this.assets[i].value != null && this.assets[i].value.length > 0) {
            total += parseFloat(this.assets[i].value.replace(/,/g, ""))
          }
        }

        return "$" + commaNumber(total)
      },
		}
	}
</script>